import { useQuery } from "@tanstack/react-query";
import { Datanode } from "@graylog/server-api";
const fetchIsDatanodeConfigured = async () => Datanode.runsWithDataNode();
const useIsDatanodeConfigured = () => {
  const { data: isDatanodeConfigured, isInitialLoading: isLoading } = useQuery({
    queryKey: ["IsDatanodeConfigured"],
    queryFn: fetchIsDatanodeConfigured
  });
  return {
    isDatanodeConfigured,
    isLoading
  };
};
export default useIsDatanodeConfigured;
